import { fetchMainApi } from '@/api/index'

export const getOffers = (params = {}) => {
  const queryParams = new URLSearchParams()

  if (params.offer_status_id) {
    queryParams.append('offer_status_id', params.offer_status_id)
  }

  if (params.order_uuid) {
    queryParams.append('order_uuid', params.order_uuid)
  }

  if (params.sort) {
    
    queryParams.append('sort', params.sort)
  }

  if (params.page) {
    queryParams.append('page', params.page)
  }

  const queryString = queryParams.toString()
  const url = queryString ? `/offers?${queryString}` : '/offers'

  return fetchMainApi('GET', url)
}
export const getOfferByUuid = (uuid) => {
  return fetchMainApi('GET', `/offers/${uuid}`)
}

export const sendOffer = (data) =>
  fetchMainApi('POST', '/offers', {
    body: JSON.stringify(data)
  })

export const cancelOffer = (uuid) =>
  fetchMainApi('POST', `/offers/${uuid}/cancel`)

export const counterOffer = (uuid, data) =>
  fetchMainApi('POST', `/offers/${uuid}/counter`, {
    body: JSON.stringify(data)
  })


export const acceptOffer = (uuid) => {
  return fetchMainApi('POST', `/offers/${uuid}/accept`)
}

export const getOrderOffers = async (params) => {
  const searchParams = new URLSearchParams()

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        searchParams.append(key, value.toString())
      }
    })
  }

  const queryString = searchParams.toString()
  const url = queryString ? `/offers?${queryString}` : '/offers'

  return fetchMainApi('GET', url)
}

export const declineOffer = async (offerUuid, reason) => {
  return fetchMainApi('POST', `/offers/${offerUuid}/decline`, {
    body: JSON.stringify({ reason })
  })
}


